import clsx from 'clsx';

import { EstimatorInfoTooltip } from './EstimatorInfoTooltip';

interface Props {
  description?: string;
  isSelected: boolean;
  label: string;
  onClick: () => void;
  tooltip?: string;
}

const handleKeyDown = (onClick: () => void) => (event: React.KeyboardEvent<HTMLDivElement>) => {
  if (event.key === 'Enter' || event.key === ' ') {
    event.preventDefault();
    onClick();
  }
};

export const EstimatorOptionCard: React.FC<Props> = ({
  description,
  isSelected,
  label,
  onClick,
  tooltip,
}) => (
  <div className="relative">
    <div
      aria-pressed={isSelected}
      className={clsx(
        'w-full cursor-pointer rounded-[20px] border p-5 text-left transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-primary/60',
        {
          'border-primary bg-primary/10': isSelected,
          'border-white/10 bg-white/5 hover:border-white/30': !isSelected,
        },
      )}
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={handleKeyDown(onClick)}>
      <div className="flex justify-between md:justify-start items-start gap-2 mb-2 pr-2 text-lg font-semibold text-white w-full">
        <span>{label}</span>
        {!!tooltip && <EstimatorInfoTooltip content={tooltip} />}
      </div>
      {!!description && <div className="text-sm leading-6">{description}</div>}
    </div>
  </div>
);
